// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[2].use[2]!../../../styles/typography.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * == BSD2 LICENSE ==
 * Copyright (c) 2016, Tidepool Project
 *
 * This program is free software; you can redistribute it and/or modify it under
 * the terms of the associated License, which is identical to the BSD 2-Clause
 * License as published by the Open Source Initiative at opensource.org.
 *
 * This program is distributed in the hope that it will be useful, but WITHOUT
 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
 * FOR A PARTICULAR PURPOSE. See the License for more details.
 *
 * You should have received a copy of the License along with this program; if
 * not, you can obtain one from Tidepool Project at tidepool.org.
 * == BSD2 LICENSE ==
 */

.TwoOptionToggle--container--OdIe3 {
  display: flex;
  align-items: center;
}

.TwoOptionToggle--label--lB1hx {
  padding: 4px;
}

.TwoOptionToggle--active--ivP8e {
  font-weight: bold;
}

.TwoOptionToggle--toggle--B8rXE {
  display: inline-block;
  position: relative;

  background-color: transparent;
  border: 0;
  cursor: pointer;
  padding: 0;
  user-select: none;
}

.TwoOptionToggle--disabled--qOCdW {
  cursor: not-allowed;
  opacity: 0.5;
  transition: opacity 0.25s;
}

.TwoOptionToggle--track--ATEgh {
  width: 50px;
  height: 24px;

  background-color: var(--chrome);
  border-radius: 30px;
  padding: 0;
  transition: all 0.2s ease;
}

.TwoOptionToggle--thumb--oDGxu {
  position: absolute;
  top: 1px;

  width: 22px;
  height: 22px;

  background-color: white;
  border: 1px solid var(--chrome);
  border-radius: 50%;
  box-sizing: border-box;
  transition: all 0.25s ease;
}

.TwoOptionToggle--leftThumb--WFiaf {
  left: 1px;
}

.TwoOptionToggle--rightThumb--mshdP {
  left: 27px;
}
`, "",{"version":3,"sources":["webpack://./src/components/common/controls/TwoOptionToggle.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;EAeE;;AAEF;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EAEE,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;;EAElB,6BAA6B;EAC7B,SAAS;EACT,eAAe;EACf,UAAU;EACV,iBAAiB;AACnB;;AAEA;EAEE,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;;EAEZ,+BAA+B;EAC/B,mBAAmB;EACnB,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;;EAER,WAAW;EACX,YAAY;;EAEZ,uBAAuB;EACvB,+BAA+B;EAC/B,kBAAkB;EAClB,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EAEE,SAAS;AACX;;AAEA;EAEE,UAAU;AACZ","sourcesContent":["/*\n * == BSD2 LICENSE ==\n * Copyright (c) 2016, Tidepool Project\n *\n * This program is free software; you can redistribute it and/or modify it under\n * the terms of the associated License, which is identical to the BSD 2-Clause\n * License as published by the Open Source Initiative at opensource.org.\n *\n * This program is distributed in the hope that it will be useful, but WITHOUT\n * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS\n * FOR A PARTICULAR PURPOSE. See the License for more details.\n *\n * You should have received a copy of the License along with this program; if\n * not, you can obtain one from Tidepool Project at tidepool.org.\n * == BSD2 LICENSE ==\n */\n\n.container {\n  display: flex;\n  align-items: center;\n}\n\n.label {\n  composes: mediumContrastText smallSize from '../../../styles/typography.css';\n  padding: 4px;\n}\n\n.active {\n  font-weight: bold;\n}\n\n.toggle {\n  display: inline-block;\n  position: relative;\n\n  background-color: transparent;\n  border: 0;\n  cursor: pointer;\n  padding: 0;\n  user-select: none;\n}\n\n.disabled {\n  composes: toggle;\n  cursor: not-allowed;\n  opacity: 0.5;\n  transition: opacity 0.25s;\n}\n\n.track {\n  width: 50px;\n  height: 24px;\n\n  background-color: var(--chrome);\n  border-radius: 30px;\n  padding: 0;\n  transition: all 0.2s ease;\n}\n\n.thumb {\n  position: absolute;\n  top: 1px;\n\n  width: 22px;\n  height: 22px;\n\n  background-color: white;\n  border: 1px solid var(--chrome);\n  border-radius: 50%;\n  box-sizing: border-box;\n  transition: all 0.25s ease;\n}\n\n.leftThumb {\n  composes: thumb;\n  left: 1px;\n}\n\n.rightThumb {\n  composes: thumb;\n  left: 27px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `TwoOptionToggle--container--OdIe3`,
	"label": `TwoOptionToggle--label--lB1hx ${___CSS_LOADER_ICSS_IMPORT_0___.locals["mediumContrastText"]} ${___CSS_LOADER_ICSS_IMPORT_0___.locals["smallSize"]}`,
	"active": `TwoOptionToggle--active--ivP8e`,
	"toggle": `TwoOptionToggle--toggle--B8rXE`,
	"disabled": `TwoOptionToggle--disabled--qOCdW TwoOptionToggle--toggle--B8rXE`,
	"track": `TwoOptionToggle--track--ATEgh`,
	"thumb": `TwoOptionToggle--thumb--oDGxu`,
	"leftThumb": `TwoOptionToggle--leftThumb--WFiaf TwoOptionToggle--thumb--oDGxu`,
	"rightThumb": `TwoOptionToggle--rightThumb--mshdP TwoOptionToggle--thumb--oDGxu`
};
export default ___CSS_LOADER_EXPORT___;
